import React, { useCallback, useRef } from 'react';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import { useNavigate, useLocation } from 'react-router-dom';

import api from '../../../services/api';

import { useToast } from '../../../hooks/toast';
import getValidationErrors from '../../../utils/getValidationErrors';

import FormSurveyText from '../Form';

interface SurveyText {
  title: string;
  text: string;
  defaultLanguageId: number;
  textTranslated: string;
  translationLanguageId: number;
}

const CreateSurveyText: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const location = useLocation();
  const { isStartText } = location.state || {};
  const state = { isStartText };
  const { addToast } = useToast();
  const navigate = useNavigate();

  const handleSubmit = useCallback(
    async (data: SurveyText) => {
      try {
        formRef.current?.setErrors({});

        const translations = [
          {
            text: data.textTranslated,
            languageId: data.translationLanguageId,
          },
        ];

        const surveyTextInsert = {
          translations,
          title: data.title,
          text: data.text,
          defaultLanguageId: data.defaultLanguageId,
          isStartText: state.isStartText,
        };

        const schema = Yup.object().shape({
          title: Yup.string().required('The title is required'),
          text: Yup.string().required('The text required'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        await api.post('/surveyTexts', surveyTextInsert);

        const redirectUrl =
          state.isStartText === true
            ? '/surveyTexts/type/start'
            : '/surveyTexts/type/final';

        navigate(redirectUrl);

        addToast({
          type: 'success',
          title: 'Success',
          description: 'The text was created successfully!',
        });
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current?.setErrors(errors);

          return;
        }

        addToast({
          type: 'error',
          title: 'Registration Error',
          description:
            'An error occurred while creating the text, please try again.',
        });
      }
    },
    [addToast, navigate, state.isStartText],
  );

  return (
    <>
      <h1>New {state.isStartText === true ? 'Start' : 'Final'} Text</h1>

      <FormSurveyText
        formRef={formRef}
        handleSubmit={handleSubmit}
        buttonText="Create"
      />
    </>
  );
};

export default CreateSurveyText;
